<div class="modal-header">
  <h5 class="modal-title">Remove application</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form>
    <span>Do you really want to remove this application? </span>
    <div class="flex-grow-1 py-2">
      <h6 class="mb-1">{{ app?.bundleName }}</h6>
      <p class="mb-0 lh-1">
        <small>Version: {{ app?.shortVersionString }} ({{ app?.bundleVersion }})</small><br />
        <small>Bundle ID: {{ app?.bundleIdentifier }}</small>
      </p>
    </div>
    <div>
      <input id="removeAll"
             type="checkbox"
             [formControl]="removeAllForm" />
      <label class="form-check-label"
             for="removeAll">Remove all versions</label>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-primary align-self-end"
          (click)="onSubmit()">
    <fa-icon icon="check"></fa-icon>
    <span class="ms-2">Confirm</span>
  </button>
  <button type="button"
          class="btn btn-secondary align-self-end"
          (click)="modal.dismiss('Cancel click')">
    <fa-icon icon="times"></fa-icon>
    <span class="ms-2"
          i18n>Cancel</span>
  </button>
</div>